define('bindingHandlers/dataTable/dynamicColumnsDataTable',[
    'jquery',
    'lib/knockout',
    'lib/lodash4',

    'bindingHandlers/dataTable/dataTable'
], function (
    $,
    ko,
    _
    ) {

    "use strict";

    ko.bindingHandlers.dynamicColumnsDataTable = {
        init: function(element, valueAccessor) {
            var options = ko.unwrap(valueAccessor());

            /**
             * COLUMNS
             * The following required properties will allow a consumer to add columns dynamically if they don't know the
             * columns during the creation of template. Dynamic columns should have the following information in order
             * to generate them correctly:
             *      label           = name of column
             *      id              = id of column
             *      class           = column class(es)
             *      cellTemplate    = template for rendered cells
             *                        examples: <span data-bind="text: someValue"></span> or
             *                                  <a data-bind="attr: { href: someHref }"></a>
             *
             */

            var dynamicColumns = ko.unwrap(options.columns);

            /**
             *  Take each column passed into the BH and create a row template that will be passed on to the dataTable BH
             */
            _.each(dynamicColumns, function(columnData) {
                $(element).find("[data-row]").append($('<div data-column="'+ columnData.id + '" class="' + columnData.class + '">' +
                    columnData.cellTemplate + '</div>'));
            });

            ko.bindingHandlers.dataTable.init.apply(this, arguments);

            return {controlsDescendantBindings: true};
        }
    };
});

